// src/App.jsx or src/App.tsx

import React, { useState, useEffect } from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import RepublicaTransfer from "./RepublicaTransfer";
import TransferHistory from "./TransferHistory";
import TransferDownload from "./TransferDownload";
import ErrorPage from "./ErrorPage";
import Login from "./Login";

import { hasTransferPermission } from "./constants/Requests";

import { checkSessionToken, getTokenFromStorage, deleteUserAndTokenInStorage } from './helpers/AuthHelper/AuthHelperV2';

const App = () => {

  const [loading, setLoading] = useState(true); // track async call
  const [isAuthorized, setIsAuthorized] = useState(false); // result of async check


  useEffect(() => {
    async function checkAccess() {
      try {

        var auth = await checkSessionToken();
        var token = getTokenFromStorage();

        if(!auth){
          return;
        }

        var hasTransferPermision = await hasTransferPermission(token);

        if(!hasTransferPermision){
          setIsAuthorized(false);
          deleteUserAndTokenInStorage();
          return;
        }
        setIsAuthorized(true);

      } catch (err) {
        setIsAuthorized(false);
      } finally {
        setLoading(false);
      }
    }

    checkAccess();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
      <BrowserRouter>
        <Routes>          
          <Route path="/dl/:transferId" element={<TransferDownload />}/>
          <Route path="/" element={ !isAuthorized ? <Login /> : <RepublicaTransfer/>} />
          <Route path="/history" element={!isAuthorized ? <ErrorPage/> : <TransferHistory />}/>
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />}/>
        </Routes>
      </BrowserRouter>
  );
};

export default App;